import React, {Component, PropTypes} from 'react'
import {connect} from 'react-redux'
import {Button, ButtonToolbar, Popover} from 'react-bootstrap'
import extract from '../../core/extract'
import Icon from '../../core/components/Icon'
import {sendRemoveLinkFromPatrimonyContactCmd, loadContact} from '../actions'
import i18n from '../i18n'
import style from './RemoveLinkFromPatrimonyContactPopover.less'

class RemoveLinkFromPatrimonyContactPopover extends Component {

    static propTypes = {
        onHide: PropTypes.func.isRequired
    }

    _sendRemoveCmd(event, linkedWith) {
        const {dispatch} = this.props

        event.preventDefault()
        dispatch(sendRemoveLinkFromPatrimonyContactCmd(linkedWith)).then(() => {
            return dispatch(loadContact())
        })
    }

    render() {
        const {dispatch, contact, onHide, ...others} = this.props

        return (
            <Popover
                title={i18n.unlinkPatrimonyContact}
                {...others}>
                    <ul className={style.linkedWithGroup}>
                        {contact.linkedWith.map((linkedWith, index) => (
                            <li key={index}>
                                <a
                                    href=''
                                    className={style.remove}
                                    onClick={(e) => this._sendRemoveCmd(e, linkedWith)}>
                                    <Icon icon='minus' size='xs' />
                                </a>
                                <p>
                                    {linkedWith.linkType == 'LinkToPatrimonyAsHomeOwnerAssociation' && (
                                        <label>{extract(i18n.homeOwnerAssociationPositionEnum, linkedWith.position)} -</label>
                                    )}
                                    {linkedWith.linkType != 'LinkToPatrimonyAsHomeOwnerAssociation' && (
                                        <label>{extract(i18n.patrimonyContactLinkTypeEnum, linkedWith.linkType)} -</label>
                                    )}
                                    {linkedWith.patrimony && (
                                        <span> {linkedWith.patrimony.label}</span>
                                    )}
                                    {linkedWith.patrimony && linkedWith.patrimony.ref && (
                                        <span> ({linkedWith.patrimony.ref})</span>
                                    )}
                                    {linkedWith.lot && (
                                        <span> {linkedWith.lot.ref}</span>
                                    )}
                                </p>
                            </li>
                        ))}
                    </ul>
                    <ButtonToolbar>
                        <Button
                            bsSize='large'
                            onClick={onHide}>
                            {i18n.cancel}
                        </Button>
                    </ButtonToolbar>
            </Popover>
        )
    }
}

RemoveLinkFromPatrimonyContactPopover = connect((state) => ({
    contact: state.patrimony.contact.contact
}))(RemoveLinkFromPatrimonyContactPopover)

export default RemoveLinkFromPatrimonyContactPopover


// WEBPACK FOOTER //
// ./lib/patrimony/components/RemoveLinkFromPatrimonyContactPopover.js